import { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { FormInput } from '../../../components/input/index';
import { useReactForm } from '../../../hooks/index';
import { FormSchema, formSchema } from './modals.validation';

export type RenameModalProps = {
  currentName?: string;
  isPending?: boolean;
  onClose: () => void;
  onSuccess: (name: string | undefined) => void;
  scenarioNames?: string[];
};

export const RenameModal: FC<RenameModalProps> = ({
  onClose,
  onSuccess,
  currentName,
  scenarioNames,
  isPending,
}) => {
  const { control } = useReactForm({
    schema: formSchema,
  });
  const { name } = useWatch<FormSchema>({ control });
  const { success } = formSchema.safeParse({ name });

  const trimName = name?.trim().toLocaleLowerCase();
  const trimCurrentName = currentName?.trim().toLocaleLowerCase();
  const isNameDuplicates =
    trimName && trimName !== trimCurrentName ? scenarioNames?.includes(trimName) : false;

  const isValid = success && !isNameDuplicates;

  const handleRename = () => {
    onSuccess(name?.trim());
  };

  return (
    <div className="m-2 flex w-full max-w-[493px] flex-col gap-8 rounded bg-white p-4">
      <div className="flex flex-col gap-4">
        <span className="text-xl font-semibold text-gray-700">
          <AppFormattedMessage id="RENAME" /> <AppFormattedMessage id="SCENARIO" />
        </span>
        <FormInput
          control={control}
          defaultValue={currentName}
          errorMessage={
            isNameDuplicates && <AppFormattedMessage id="SCENARIO_NAME_ALREADY_EXISTS" />
          }
          name={'name'}
          placeholder={<AppFormattedMessage id="SCENARIO_NAME" />}
          wrapperClassName={'transition-all duration-1000 w-full'}
        />
      </div>
      <div className="flex h-11 w-full justify-end gap-3">
        <Button
          className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
          onClick={onClose}
          styleType="NONE"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <Button
          className="h-full w-fit bg-brand-700 px-6 py-[10px] text-sm font-[550] text-white"
          disabled={!isValid || trimName === trimCurrentName}
          isLoading={isPending}
          onClick={handleRename}
          styleType="NONE"
        >
          <AppFormattedMessage id="SAVE" />
        </Button>
      </div>
    </div>
  );
};
